import { Component, HostListener, OnInit, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { FilterService } from 'src/app/services/filter.service';
import { ImageManager } from 'src/app/shared/image-manager';
import { Filter } from 'src/app/shared/object/filter';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'xplorer-bowser-categories',
    templateUrl: './categories.component.html',
    styleUrls: ['./categories.component.css'],
    imports: [TranslateModule]
})
export class CategoriesComponent implements OnInit {
  categories: Filter[] = [];
  displayedCategories: Filter[] = [];
  screenWidth: number;

  protected readonly ImageManager = ImageManager;

  private router: Router = inject(Router);
  private filterService: FilterService = inject(FilterService);
  private platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);


  ngOnInit(): void {
    this.screenWidth = this.isBrowser ? window.innerWidth : 375;
    this.loadCategories();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (!this.isBrowser) {
      return;
    }
    this.screenWidth = window.innerWidth;
    this.updateDisplayedCategories();
  }

  loadCategories(): void {
    this.filterService.initFilters();
    this.categories = this.filterService.getFilters();

    this.updateDisplayedCategories();
  }

  updateDisplayedCategories(): void {
    this.displayedCategories = this.categories.slice(0, 6);
  }

  navigateTo(category: Filter): void {
    this.router.navigate(['search'], { queryParams: { tag: category.API_name } });
  }

}
